import { render } from "./MenuLeftContextAction.vue?vue&type=template&id=54fc83b0"
import script from "./MenuLeftContextAction.vue?vue&type=script&lang=js"
export * from "./MenuLeftContextAction.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__